
<div class="wrapper">
  <div class="head">
    <reb-ngx-label mood="none" size="22" weight="500">Companies</reb-ngx-label>
  </div>
  <div class="banner-wrapper" *ngIf="hasMessage">
    <reb-ngx-banner [mood]="moodMessage" [message]="message"></reb-ngx-banner>
  </div>
  <div *ngIf="!hasMessage" class="content">
    <form class="form" [formGroup]="form">
      <div class="section">
        <div class="row">
          <mat-form-field appearance="outline"  class="autocomplete-hidelabel size size1of1">
            <input type="text"
            placeholder="Select company"
                   aria-label="Select company"
                   matInput
                   [formControlName]="'company'"
                   [matAutocomplete]="auto">
            <mat-autocomplete    (optionSelected)="onSelectCompany($event)" autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
              <mat-option *ngFor="let company of filteredCollectionOfUserCompany" [value]="company">
                {{ company?.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="row">
          <reb-ngx-label mood="none" size="14" weight="700" class="company-hint">Don't see your company?
            <a class='custom-mat-link active' [routerLink]="['/login']">Change user</a>
          </reb-ngx-label>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="!hasMessage" class="nav">
    <reb-ngx-mat-button
        class="size size1of1"
        data-test="btnContinue"
        [disabled]="disableButton"
        size="medium"
        width="size1of1"
        (clickHandler)="navigateToDashboard()"
        >
        CONTINUE
    </reb-ngx-mat-button>
  </div>
</div>
